var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,12 L6,8 L6,11 L15,11 L15,13 L6,13 L6,16 L2,12 Z M8,4 L8,9 L9.99,9 L9.99,4 L20.02,4 L20.02,20 L9.99,20 L9.99,15 L8,15 L8,20 C8,21.1 8.9,22 10,22 L20,22 C21.1,22 22,21.1 22,20 L22,4 C22,2.9 21.1,2 20,2 L10,2 C8.9,2 8,2.9 8,4 Z",
    id: "svg-501323933a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.000000, -970.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 968.000000)"
  }, /*#__PURE__*/React.createElement("mask", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-501323933a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "evenodd",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000)",
    xlinkHref: "#svg-501323933a"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.c3bf9e3fa2fe2c73585075845d4c495f.svg";